import { ReactNode } from "react"
import { Container } from "rsuite"
import { LogoIcon } from "../SvgLoader"
import Version from "../Version"

const svgEmtpyTabsStyle: React.CSSProperties = {
    width: '20em',
    maxWidth: '100%',
    fill: '#000',
    alignSelf: 'center',
    justifySelf: 'center',
    //fill: 'var(--special-color-1)',
    maxHeight: '100%',

}

type ContentLogoPros = { children?: ReactNode }
export default function ContentLogo({ children }: ContentLogoPros) {
    return (
        <Container className="empty-content-logo">
            <div className="empty-content-children">
                {children}
            </div>
            <LogoIcon style={svgEmtpyTabsStyle} />
            <Version />
        </Container>
    )
}